import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useIntl, FormattedMessage } from "react-intl";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import basicAuthRequest from "axios/basicAuthRequest";
import { AUTH_ROOT_ROUTE, LOGIN_ROUTE } from "routes/auth/authPaths";
import { SrAlert, SrButton, SrInput } from "../../common";
import { AUTH_CONTAINER_WIDTH, AUTH_TITLE_SPACE } from "../../../constants";
import { ACCOUNT_RESET_PASSWORD } from "../../../constants/api";
import { validations } from "utils";

const initialValues = {
  email: "",
};

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: AUTH_CONTAINER_WIDTH,
  },
  formWidth: {
    width: "100%",
  },
  buttonsMargin: {
    "& > button": {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    "& > button:first-child": {
      marginLeft: 0,
    },
    "& > button:last-child": {
      marginRight: 0,
    },
  },
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const [error, setError] = useState("");
  const intl = useIntl();

  const onSubmit = async (values) => {
    setError("");

    try {
      await basicAuthRequest.post(ACCOUNT_RESET_PASSWORD, {
        username: values.email,
      });
      toast.success(intl.formatMessage({ id: "auth.forgotPasswordEmailSent" }));
      history.push(`${AUTH_ROOT_ROUTE}${LOGIN_ROUTE}`);
    } catch (err) {
      setError(
        err.response?.data?.error?.message ||
          intl.formatMessage({ id: "errors.somethingWrong" })
      );
    }
  };

  const onCancelBtnClick = () => {
    history.push(`${AUTH_ROOT_ROUTE}${LOGIN_ROUTE}`);
  };

  const validationSchema = Yup.object().shape({
    email: validations.email.required(
      intl.formatMessage({ id: "common.requiredField" })
    ),
  });

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        item
        xs={12}
        justifyContent="center"
        className={classes.container}
      >
        <Grid container item xs={12} justifyContent="center">
          <Box mb={AUTH_TITLE_SPACE}>
            <Typography variant="h2" align="center">
              <FormattedMessage id="auth.forgotMyPassword" />
            </Typography>
          </Box>
          <Box mb={AUTH_TITLE_SPACE}>
            <Typography variant="h5" align="center">
              <FormattedMessage id="auth.receiveEmail" />
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Formik
            fullWidth
            initialValues={initialValues}
            validateOnChange="true"
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              touched,
              values,
              isSubmitting,
            }) => (
              <Form noValidate className={classes.formWidth}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <SrInput
                      label={intl.formatMessage({ id: "common.email" })}
                      margin="normal"
                      required
                      fullWidth
                      error={Boolean(errors.email && touched.email)}
                      helperText={touched.email && errors.email}
                      id="email"
                      name="email"
                      autoComplete="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                  </Grid>
                  {error && (
                    <Grid item xs={12}>
                      <SrAlert severity="error">{error}</SrAlert>
                    </Grid>
                  )}
                  <Grid item xs={12} className={classes.buttonsMargin}>
                    <SrButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                    >
                      <FormattedMessage id="common.send" />
                    </SrButton>
                    <SrButton onClick={onCancelBtnClick} variant="contained">
                      <FormattedMessage id="common.cancel" />
                    </SrButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
